import { Button, Divider, Modal } from "antd";
import { ProductProps } from "./products";
import * as React from 'react';
import "./product.sass"
import { FormattedNumber } from "react-intl";
import FormRewardBalance from "../modalReward/modalReward";
export default function Product({ product, id, height,t, setAvailableMoney, availableMoney }: { product: ProductProps, id: string, height: string, t:any, setAvailableMoney: (value: any) => void, availableMoney: any }) {
    const [isInstructionModalOpen, setIsInstructionModalOpen] = React.useState(false);
  const [visibleModal, setVisibleModal] = React.useState(false);


    return <>
        <Modal footer={null} visible={isInstructionModalOpen} onCancel={() => setIsInstructionModalOpen(false)} title={product.traductions[0]?.title}>
            <p><strong>{t('instructions-change')} </strong></p>
            <p>{product.traductions[0]?.instruction}</p>
        </Modal>
         <FormRewardBalance
          isModalRewardVisible={visibleModal}
          setModalRewardVisible={setVisibleModal}
          valueOpen={{
            name:"products",
              id: product.id,
              amountUser: availableMoney.money,
              amount: product?.amountDiscounts[0]?.amount, 
              idCurrency: product?.amountDiscounts[0]?.idCurrency,
                title: product?.traductions[0]?.title,
                image: product?.link || 'https://cdn.sandbox.api.beds2b.com//images/clients/115ab85a-845c-5daf-92b5-39bed6cdcbdb/landing/image-01.jpg'
          }}
          setAvailableMoney={setAvailableMoney}
          isOwn={false}
        />
        <div className="product-card">

            <div
                className="product-image"
                style={{ backgroundImage: `url(${product?.link || 'https://cdn.sandbox.api.beds2b.com//images/clients/115ab85a-845c-5daf-92b5-39bed6cdcbdb/landing/image-01.jpg'})` }}
            />

            <div className="product-border">
                <div id={id} style={{ paddingTop: 24, minHeight: height }} >
                    <p style={{ paddingBottom: 5, margin: 0 }}><strong>{product.traductions[0]?.title}</strong></p>
                    <p style={{ marginBottom: 0 }}>{product.traductions[0]?.description}</p>
                    {product.traductions[0]?.instruction && <Button type="link" onClick={() => setIsInstructionModalOpen(true)}>{t('instructions-change')}</Button>}
                </div>

                <Divider />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, padding: "0 10px 0 10px" }}>
                    <p style={{ color: 'gray', textDecoration: 'line-through', margin: 0, fontSize: 18 }}>

                        {product.amountOriginals[0]?.amount ? <FormattedNumber
                            value={product.amountOriginals[0]?.amount}
                            style="currency"
                            currency={product.amountOriginals[0]?.idCurrency}
                        /> : "N/A"}

                    </p>
                    <p style={{ margin: 0, fontSize: 18 }}>
                        <strong>
                            {product.amountDiscounts[0]?.amount ? <FormattedNumber
                                value={product.amountDiscounts[0]?.amount}
                                style="currency"
                                currency={product.amountDiscounts[0]?.idCurrency}
                            /> : "N/A"}
                        </strong>
                    </p>


                    <Button style={{ flex: "1" }} type="primary" disabled={!product.isActive || availableMoney?.money <= 0} onClick={() => setVisibleModal(true)}>{t("redeem")}</Button>

                </div>
            </div>
        </div>
    </>
}